module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/selectbox/selectbox.component.scss
// module id = ./src/app/modules/base-module/components/selectbox/selectbox.component.scss
// module chunks = 9